import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "@react/shared/ui/Modal"
import Button from "@react/shared/ui/Button"
import { t, fmtDay } from "../helpers/format"

const CloseModal = ({ isOpen, to, busy, onCancel, onConfirm }) => {
  const [agreed, setAgreed] = useState(false)
  useEffect(() => { if (isOpen) setAgreed(false) }, [isOpen])

  const date = to ? fmtDay(to, { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : ""

  return (
    <Modal
      isOpen  = {isOpen}
      onClose = {onCancel}
      size    = "sm"
      eyebrow = {t("close.eyebrow")}
      title   = {t("close.title")}
      footer  = {(
        <div className="flex items-center justify-between w-full">
          <Button variant="secondary" onClick={onCancel}>{t("actions.cancel")}</Button>
          <Button variant="primary" disabled={!agreed || busy} onClick={onConfirm}>
            <FontAwesomeIcon icon={busy ? "circle-notch" : "lock"} spin={busy} />
            {t("close.confirm")}
          </Button>
        </div>
      )}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start gap-3 p-3 rounded-lg bg-slate-50 border border-slate-200">
          <span className="inline-grid place-items-center w-[32px] h-[32px] shrink-0 rounded-lg bg-slate-700 text-white">
            <FontAwesomeIcon icon="lock" />
          </span>
          <p className="text-[13px] leading-relaxed text-slate-700 m-0">
            {t("close.body", { date })}
          </p>
        </div>
        <ul className="flex flex-col gap-1.5 text-[12.5px] text-slate-600 pl-0 m-0 list-none">
          <li className="flex gap-2"><FontAwesomeIcon icon="check" className="mt-[3px] text-emerald-500" />{t("close.point_approved")}</li>
          <li className="flex gap-2"><FontAwesomeIcon icon="ban" className="mt-[3px] text-slate-400" />{t("close.point_others")}</li>
          <li className="flex gap-2"><FontAwesomeIcon icon="file-excel" className="mt-[3px] text-slate-400" />{t("close.point_export")}</li>
        </ul>
        <label className="flex items-start gap-2.5 p-3 rounded-lg border border-slate-200 cursor-pointer hover:bg-slate-50 m-0">
          <input
            type      = "checkbox"
            checked   = {agreed}
            onChange  = {e => setAgreed(e.target.checked)}
            className = "mt-[2px] w-[16px] h-[16px] accent-brand-500"
          />
          <span className="text-[13px] font-medium text-slate-800">{t("close.agree", { date })}</span>
        </label>
      </div>
    </Modal>
  )
}

export default CloseModal
